import { Employee, EmployeeProps, Practitioner } from '@customTypes/Practitioner'
import { PatientTypeOptions } from 'src/config/patientTypeOptions'
import { publicClient } from './apiClients'
import { getPractitionerFromEmployee, getPractitionersFromEmployees } from './mappers'
import { InsuranceTypeOptions } from 'src/config/insuranceTypeOptions'

export const getPractitioners = async (
  clinicReferenceId: string,
  treatmentBundleReferenceId: string,
  patientType: PatientTypeOptions,
  start: Date,
  end: Date,
  insuranceType?: InsuranceTypeOptions
): Promise<Practitioner[]> => {
  const params: EmployeeProps = {
    treatmentBundleReferenceId,
    start: start.toISOString(),
    end: end.toISOString(),
    patientType,
    clinicReferenceId,
    insuranceType,
  }
  const { data } = await publicClient.get<Employee[]>(`/employees`, {
    params,
  })
  return getPractitionersFromEmployees(data)
}

interface GetRecommendedParams {
  clinicReferenceId: string
  treatmentBundleReferenceId: string
  start: string
  patientType: PatientTypeOptions
  employeeReferenceIds?: string[]
  insuranceType?: InsuranceTypeOptions
}

export const getRecommendedPractitionerForSlot = async ({
  clinicReferenceId,
  treatmentBundleReferenceId,
  start,
  patientType,
  employeeReferenceIds,
  insuranceType,
}: GetRecommendedParams): Promise<Practitioner> => {
  const { data } = await publicClient.get('/employees/suggested', {
    params: {
      clinicReferenceId,
      treatmentBundleReferenceId,
      start,
      patientType,
      employeeReferenceIds: employeeReferenceIds?.join(','),
      insuranceType,
    },
  })

  return getPractitionerFromEmployee(data)
}

export const getAllPractitionersByIds = async (
  clinicReferenceId: string,
  employeeReferenceIds: string[]
): Promise<Practitioner[]> => {
  const { data } = await publicClient.get<Employee[]>(
    `/employees/list?clinicReferenceId=${clinicReferenceId}&employeeReferenceIds=${employeeReferenceIds.join(',')}`,
    {}
  )

  return getPractitionersFromEmployees(data)
}
